import React, { useState, useEffect, useContext } from "react";
import style from "styles/review_widget.module.scss";
import { Input, Button } from "components";
import { API } from "aws-amplify";
import ShopContext from "context/ShopContext";
import useRouter from "use-react-router";

const Reviewing = ({ shopContext, user }) => {
  const [expanded, setExpanded] = useState(false);
  const [isRatingVisible1, setIsRatingVisible1] = useState(false);
  const [isRatingVisible2, setIsRatingVisible2] = useState(false);
  const [hoverRate, setHoverRate] = useState(-1);
  const [selectedRate, setSelectedRate] = useState(-1);
  const [review, setReview] = useState("");
  const [progress, setProgress] = useState(0);
  const { AppLocalStorage } = useContext(ShopContext)
  const { location } = useRouter();
  const [hasReview, setHasReview] = useState(
    !!AppLocalStorage.getItem("review_clicked")
  );
  const [state, setState] = useState({
    submited_negative_feedback: false,
    submitting: false
  });

  const hoverHandler = (rating) => {
    if (progress >= 100) return;
    setHoverRate(rating);
    // console.log("hover on rating")
    // const stars = document.getElementsByClassName('rating_star');
    // Array.from(stars).forEach(star => {
    //   star.style.color = rating >= star.dataset.value ? 'yellow' : 'gray';
    // });
  };

  useEffect(() => {
    if (!expanded) {
      setIsRatingVisible1(false);
      setIsRatingVisible2(false);
      setHoverRate(-1);
      setSelectedRate(-1);
    }
  }, [expanded]);

  const task1 = shopContext.state.settings.active ? 33 : 0;
  const task2 = shopContext.state.campaigns.length ? 33 : 0;

  useEffect(() => {
    let _progress = task1 + task2;
    const hasReview = AppLocalStorage.getItem("review_clicked");
    if (hasReview) {
      _progress = 100;
    }
    setProgress(_progress);
  }, []);

  const handleReviewSaved = () => {
    AppLocalStorage.setItem("review_clicked", true);
    setHasReview(true);
    setProgress(100);
    setIsRatingVisible1(false);
    setIsRatingVisible2(false);
  };

  const handleAcceptToReviewOnShopify = () => {
    handleReviewSaved();

    window.open(
      "https://apps.shopify.com/monster-upsells?#modal-show=ReviewListingModal"
    );
  };

  const onStarClick = (rating) => {
    if (progress >= 100) return;
    setSelectedRate(rating);
    if (rating < 4) {
      setIsRatingVisible2(false);
      setIsRatingVisible1(true);
    } else {
      setIsRatingVisible1(false);
      setIsRatingVisible2(true);
    }
  };
  const andleExpand = () => {
    setExpanded(!expanded);
  };

  const sendReview = () => {
    setState((old) => ({
      ...old,
      submitting: true
    }));
    API.post("API_GATEWAY_NEW", "/review", {
      body: {
        rate: selectedRate,
        review
      }
    })
      .then(({ data }) => {
        handleReviewSaved();
        setState((old) => ({
          ...old,
          submited_negative_feedback: true
        }));
        // show thank you msg
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setState((old) => ({
          ...old,
          submitting: false
        }));
      });
  };
  if (location.pathname === "/campaigns") {
    return null;
  }
  return !hasReview && window.location.pathname.indexOf("affiliation") == -1 ? (
    <div className={style.floating}>
      <div className={style.checklist}>
        <div className={style.btn} onClick={andleExpand}>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="stars"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="svg-inline--fa fa-stars fa-w-16 fa-2x"
            style={{ fill: "white", color: "white" }}
          >
            <path
              fill="currentColor"
              d="M259.69042,85.96457l49.64549,20.69969,20.70353,49.643a6.65746,6.65746,0,0,0,11.926,0L362.667,106.66426l49.64549-20.69969a6.66574,6.66574,0,0,0,0-11.92493L362.667,53.338,341.96545,3.697a6.65746,6.65746,0,0,0-11.926,0L309.33591,53.338,259.69042,74.03964a6.66574,6.66574,0,0,0,0,11.92493ZM364.294,267.29343,259.4951,251.99764l-46.90716-95.19633c-8.39078-16.99879-32.68813-17.2019-41.18829,0l-46.90716,95.19633L19.69358,267.29343C.89634,269.99636-6.71318,293.19783,6.99021,306.49376l75.90772,73.99472L64.89758,485.07476c-3.20319,18.9049,16.68782,33.107,33.29752,24.2014l93.7987-49.3871,93.79869,49.3871A22.95361,22.95361,0,0,0,319.09,485.07476L301.199,380.48848l75.89209-73.99472C390.70077,293.19783,383.09125,269.99636,364.294,267.29343ZM509.05268,219.2285,469.339,202.67109,452.7801,162.961a5.32691,5.32691,0,0,0-9.5412,0L426.678,202.67109l-39.7117,16.55741a5.33385,5.33385,0,0,0,0,9.54033L426.678,245.3282l16.56087,39.7081a5.32534,5.32534,0,0,0,9.5412,0L469.339,245.3282l39.71366-16.55937a5.33386,5.33386,0,0,0,0-9.54033Z"
            ></path>
          </svg>

          {/* <div className={style.label}> ? </div> */}
          {/* {progress < 100 && <div className={style.badge}>{3 - (task1 + task2) / 33}</div>} */}
        </div>
        <div
          className={`${style.checklist_main} ${expanded ? style.expanded : ""
            }`}
          id="monster-list"
        >
          <div className={style.checklist_container}>
            <div className={style.checklist_header}>
              <div className={style.header_content}>
                <div className={style.desc}>
                  How satisfied are you with using MonsterUpsells ?
                </div>
              </div>
              <div
                className={style.minimize}
                onClick={() => setExpanded(false)}
              >
                <svg width="16px" height="16px" viewBox="0 0 16 16">
                  <defs></defs>
                  <g id="Icon-Arrow-Down" stroke="none" fill="#999">
                    <path
                      d="M7.18944314,11.1875067 L3.20507764,7.20314121 C3.06835906,7.06642263 3,6.9004077 3,6.70509552 C3,6.50978333 3.06835906,6.3437684 3.20507764,6.20704983 L3.87890415,5.56252012 C4.01562273,5.42580154 4.18163766,5.35744248 4.37694984,5.35744248 C4.57226203,5.35744248 4.73827696,5.42580154 4.87499553,5.56252012 L7.68748882,8.37501341 L10.4999821,5.56252012 C10.6367007,5.42580154 10.8027156,5.35744248 10.9980278,5.35744248 C11.19334,5.35744248 11.3593549,5.42580154 11.4960735,5.56252012 L12.1699,6.20704983 C12.3066186,6.3437684 12.3749776,6.50978333 12.3749776,6.70509552 C12.3749776,6.9004077 12.3066186,7.06642263 12.1699,7.20314121 L8.18553451,11.1875067 C8.04881594,11.3242253 7.88280101,11.3925843 7.68748882,11.3925843 C7.49217664,11.3925843 7.32616171,11.3242253 7.18944314,11.1875067 Z"
                      id=""
                      fill="#999"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>

            <div className={style.checklist_footer}>
              {progress < 100 && (
                <div
                  className={style.stars}
                  onMouseLeave={() => setHoverRate(-1)}
                >
                  {[...Array(5).keys()].map((i) => {
                    return (
                      <div
                        className={`${style.star} rating_star`}
                        key={"start" + i}
                        data-value={i + 1}
                        onMouseOver={() => hoverHandler(i + 1)}
                        onClick={() => onStarClick(i + 1)}
                      >
                        {hoverRate >= i + 1 || selectedRate >= i + 1 ? (
                          <svg
                            width="100%"
                            height="auto"
                            viewBox="0 0 98 95"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M94.6428 33.6889L65.3848 29.4368L52.3057 2.92133C51.9485 2.19536 51.3608 1.60766 50.6348 1.25043C48.8141 0.351605 46.6016 1.10063 45.6913 2.92133L32.6122 29.4368L3.35416 33.6889C2.54752 33.8041 1.81002 34.1844 1.24537 34.7606C0.562738 35.4622 0.186579 36.4061 0.199543 37.385C0.212508 38.3638 0.613535 39.2974 1.31451 39.9807L22.4831 60.6192L17.4819 89.762C17.3646 90.4399 17.4396 91.1371 17.6984 91.7746C17.9573 92.412 18.3895 92.9642 18.9462 93.3685C19.5028 93.7728 20.1616 94.0131 20.8479 94.062C21.5341 94.1109 22.2204 93.9666 22.8288 93.6454L48.9985 79.8864L75.1682 93.6454C75.8827 94.0256 76.7124 94.1524 77.5075 94.0141C79.5126 93.6684 80.8608 91.767 80.5151 89.762L75.5139 60.6192L96.6825 39.9807C97.2587 39.4161 97.6389 38.6786 97.7542 37.8719C98.0653 35.8553 96.6594 33.9885 94.6428 33.6889Z"
                              fill="#FFC701"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="100%"
                            height="auto"
                            viewBox="0 0 98 95"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M94.6428 33.6889L65.3848 29.4368L52.3057 2.92133C51.9485 2.19536 51.3608 1.60766 50.6348 1.25043C48.8141 0.351605 46.6016 1.10063 45.6913 2.92133L32.6122 29.4368L3.35416 33.6889C2.54752 33.8041 1.81002 34.1844 1.24537 34.7606C0.562738 35.4622 0.186579 36.4061 0.199543 37.385C0.212508 38.3638 0.613535 39.2974 1.31451 39.9807L22.4831 60.6192L17.4819 89.762C17.3646 90.4399 17.4396 91.1371 17.6984 91.7746C17.9572 92.412 18.3895 92.9642 18.9462 93.3685C19.5028 93.7728 20.1616 94.0131 20.8479 94.062C21.5341 94.1109 22.2204 93.9666 22.8288 93.6454L48.9985 79.8864L75.1682 93.6454C75.8827 94.0256 76.7124 94.1524 77.5075 94.0141C79.5126 93.6684 80.8608 91.767 80.5151 89.762L75.5139 60.6192L96.6825 39.9807C97.2587 39.4161 97.6389 38.6786 97.7542 37.8719C98.0653 35.8553 96.6594 33.9885 94.6428 33.6889ZM66.6063 57.7153L70.7663 81.9491L48.9985 70.5178L27.2307 81.9606L31.3907 57.7268L13.7829 40.5569L38.1204 37.0192L48.9985 14.9748L59.8766 37.0192L84.2141 40.5569L66.6063 57.7153Z"
                              fill="#FFC701"
                            />
                          </svg>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {expanded && (
                <div
                  className={`${style.review} ${isRatingVisible1 &&
                    !state.submited_negative_feedback &&
                    style.expanded
                    }`}
                >
                  <p>We always want to improve.</p>
                  <p style={{ marginBottom: "10px" }}>
                    Can you please tell us why you gave this rating below?
                  </p>
                  <Input
                    type="textarea"
                    placeholder="..."
                    value={review}
                    onChange={setReview}
                  />
                  <br />

                  <Button
                    type="primary"
                    text="Send"
                    onClick={sendReview}
                    loading={state.submitting}
                  />
                </div>
              )}
              {state.submited_negative_feedback && (
                <div className={`${style.review} ${style.expanded}`}>
                  <p>We really appreciate your feedback! 🙏🏻</p>
                </div>
              )}

              <div
                className={`${style.review} ${isRatingVisible2 && style.expanded
                  }`}
              >
                <p>We are so thankful you love our app!</p>
                <p style={{ marginBottom: "10px" }}>
                  Can you please leave us a review? 🙏🏻
                </p>
                <br />
                <Button
                  type="primary"
                  text="Sure can"
                  onClick={handleAcceptToReviewOnShopify}
                />
                <Button
                  style={{
                    marginTop: 10
                  }}
                  type={"secondary2"}
                  text="Not right now"
                  onClick={() => {
                    setExpanded(false);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Reviewing;
